import {
  updateTermsAndConditions,
  createTermsAndConditions,
  getTermsConditions,
  updateDigitalContent,
  createDigitalContent,
  getDigitalContent,
  getPlansList,
  createPlans,
  getPlanTemplate,
  getPlanAttributes,
  getPriceWithTemplate,
  getPlanWithTemplate,
  getPlanWithTemplateTrue,
  updatePlans,
  updatePrice,
  savePrice,
  deletePrice,
  deletePlan,
  discountTemplate,
  productDiscountTemplate,
  getDiscountCode,
  uploadDocument,
  getDocument,
  getImage,
  getExternalPlans,
  getLocaleLanguage,
  getContentTag,
  getContentTagValue,
  getPlanAttributesValue,
  createPlanContent,
  editPlanContent,
  getContentType,
  getDiscountContentType,
  getPromoContentType,
  deleteContent,
  createPlanPromo,
  viewPlanPromo,
  updatePlanPromo,
  viewPlanDiscount,
  updatePlanDiscount,
  createPlanDiscount,
  sendApprovalStatus,
  approvalActionApi,
  makerCheckActionData,
  getDcRules
} from "@/http/setup/planPrice.js";

export default {
  namespaced: true,
  state: {
    termsAndConditions: null,
    digitalContent: [],
    planList: [],
    planTemplateData: {},
    planAttribute: [],
    planAttributeValue: [],
    priceWithTemplate: {},
    planWithTempate: {},
    discountTemplate: [],
    productDiscounts: [],
    discountCodeData: [],
    document: null,
    externalPlans: [],
    localeLanguage: null,
    contentType: null,
    discountContentType: null,
    promoContentType: null,
    planWithTemplateTrue: null,
    contentTagData: null,
    contentTagValueData: null,
    planDiscountData: null,
    planPromoData: null,
    makerChecker: null,
    dcRules: [],
  },
  actions: {
    async makerCheckActionData({ commit }, data) {
      let res = await makerCheckActionData(data);
      commit("SET_MAKER_CHECK_ACTION_DATA", res.data);
      return res;
    },
    async updateTermsConditions(_, data) {
      let res = await updateTermsAndConditions(data);
      return res;
    },
    async createTermsConditions(_, payload) {
      let res = await createTermsAndConditions(payload);
      return res;
    },
    async setTermsConditions({ commit }, data) {
      commit("SET_TERMS_CONDITIONS", []);
      let res = await getTermsConditions(data);
      commit("SET_TERMS_CONDITIONS", res.data);
      return res;
    },
    async updateContent(_, data) {
      let res = await updateDigitalContent(data);
      return res;
    },
    async deleteContentAction(_, data) {
      let res = await deleteContent(data);
      return res;
    },
    async createContent(_, payload) {
      let res = await createDigitalContent(payload);
      return res;
    },
    async setDigitalContent({ commit }, id) {
      commit("SET_DIGITAL_CONTENT", []);
      let res = await getDigitalContent(id);
      commit("SET_DIGITAL_CONTENT", res.data);
      return res;
    },
    async fetchPlanList({ commit }, id) {
      let res = await getPlansList(id);
      commit("SET_PLAN_LIST", res.data.pageItems);
      return res;
    },
    async fetchDcRules({ commit },) {
      let res = await getDcRules();
      commit("SET_DC_RULE", res.data);
      return res;
    },
    async createPlanAction(_, data) {
      const resp = await createPlans(data);
      return resp;
    },
    async setPlanTemplateData({ commit }) {
      const resp = await getPlanTemplate();
      commit("SET_PLAN_TEMPLATE", resp.data);
      return resp;
    },
    async setPlanAttributes({ commit }) {
      const resp = await getPlanAttributes();
      commit("SET_PLAN_ATTRIBUTES", resp.data);
      return resp;
    },
    async setPlanAttributesValue({ commit }) {
      const resp = await getPlanAttributesValue();
      commit("SET_PLAN_ATTRIBUTES_VALUE", resp.data);
      return resp;
    },
    async getExternalPlansAction({ commit }) {
      const resp = await getExternalPlans();
      commit("SET_EXTERNAL_PLANS", resp.data);
      return resp;
    },
    async setDiscountCodeData({ commit }) {
      const pageItems = await getDiscountCode();
      commit("SET_DISCOUNT_CODE", pageItems.data);
      return pageItems;
    },
    async setPriceWithTemplate({ commit }, id) {
      const template = await getPriceWithTemplate(id);
      commit("SET_PRICE_WITH_TEMPLATE", template.data);
      return template;
    },
    async getPlanById({ commit }, id) {
      const template = await getPlanWithTemplate(id);
      commit("GET_PLAN_BY_ID", template.data);
      return template;
    },
    async approvalAction(_, payload) {
      return await approvalActionApi(payload);
    },
    async getPlanWithTemplateTrueAction({ commit }, id) {
      const template = await getPlanWithTemplateTrue(id);
      commit("GET_PLAN_TEMPLATE", template.data);
      return template;
    },
    async getLocaleLanguageAction({ commit }) {
      const res = await getLocaleLanguage();
      commit("GET_LOCALE_LANGUAGE", res.data);
      return res;
    },
    async getContentTagAction({ commit }) {
      const res = await getContentTag();
      commit("GET_CONTENT_TAG", res.data);
      return res;
    },
    async getContentTagValueAction({ commit }) {
      const res = await getContentTagValue();
      commit("GET_CONTENT_TAG_VALUE", res.data);
      return res;
    },
    async getContentTypeAction({ commit }) {
      const res = await getContentType();
      commit("GET_CONTENT_TYPE", res.data);
      return res;
    },
    async getDiscountContentTypeAction({ commit }) {
      const res = await getDiscountContentType();
      commit("GET_DISCOUNT_CONTENT_TYPE", res.data);
      return res;
    },
    async getPromoContentTypeAction({ commit }) {
      const res = await getPromoContentType();
      commit("GET_PROMO_CONTENT_TYPE", res.data);
      return res;
    },
    async updatePlanAction(_, data) {
      const resp = await updatePlans(data.id, data.data);
      return resp;
    },
    async createPlanContentAction(_, data) {
      const resp = await createPlanContent(data.screen, data.data);
      return resp;
    },
    async createPlanDiscountAction(_, data) {
      const resp = await createPlanDiscount(data);
      return resp;
    },
    async updatePlanDiscountAction(_, data) {
      const resp = await updatePlanDiscount(data);
      return resp;
    },
    async viewPlanDiscountAction({ commit }, data) {
      const resp = await viewPlanDiscount(data);
      commit("SET_PLAN_DISCOUNT_DATA", resp.data.pageItems);
      return resp;
    },
    async createPlanPromoAction(_, data) {
      const resp = await createPlanPromo(data);
      return resp;
    },
    async updatePlanPromoAction(_, data) {
      const resp = await updatePlanPromo(data);
      return resp;
    },
    async viewPlanPromoAction({ commit }, data) {
      const resp = await viewPlanPromo(data);
      commit("SET_PLAN_PROMO_DATA", resp.data.pageItems);
      return resp;
    },
    async editPlanContentAction(_, data) {
      const resp = await editPlanContent(data.screen, data.data);
      return resp;
    },
    async updatePriceAction(_, data) {
      const resp = await updatePrice(data.id, data.data);
      return resp;
    },
    async addPriceAction(_, data) {
      const resp = await savePrice(data.id, data.data);
      return resp;
    },
    async deletePriceAction(_, id) {
      const resp = await deletePrice(id);
      return resp;
    },
    async deletePlanAction(_, id) {
      const resp = await deletePlan(id);
      return resp;
    },
    async fetchDiscountTemplate({ commit }, type = "plan") {
      const resp = await discountTemplate(type);
      commit("SET_DISCOUNT_TEMPLATE", resp.data);
      return resp;
    },
    async fetchProductDiscountTemplate({ commit }) {
      const resp = await productDiscountTemplate();
      commit("SET_PRODUCT_DISCOUNT_TEMPLATE", resp.data);
      return resp;
    },
    async uploadAttachmentAction(_, data) {
      const res = await uploadDocument(data.id, data.data);
      return res;
    },
    async sendApprovalAction(_, id) {
      const res = await sendApprovalStatus(id, {
        status: 1,
      });
      return res;
    },
    async fetchAttachmentAction({ commit }, id) {
      const resp = await getDocument(id);
      if (!(resp.data && resp.data[0])) {
        commit("SET_DOCUMENT", "");
        return resp;
      }

      const image = await getImage(id, resp.data[0].id);
      commit("SET_DOCUMENT", image.data);
      return resp;
    },
  },
  mutations: {
    SET_TERMS_CONDITIONS(state, payload) {
      state.termsAndConditions = payload;
    },
    SET_DIGITAL_CONTENT(state, payload) {
      state.digitalContent = payload;
    },
    SET_PLAN_LIST(state, payload) {
      state.planList = payload;
    },
    SET_DC_RULE(state, payload) {
      state.dcRules = payload;
    },
    SET_PLAN_TEMPLATE(state, payload) {
      state.planTemplateData = payload;
    },
    SET_PLAN_ATTRIBUTES(state, payload) {
      state.planAttribute = payload;
    },
    SET_PLAN_ATTRIBUTES_VALUE(state, payload) {
      state.planAttributeValue = payload;
    },
    SET_PRICE_WITH_TEMPLATE(state, payload) {
      state.priceWithTemplate = payload;
    },
    GET_PLAN_BY_ID(state, payload) {
      state.planWithTempate = payload;
    },
    GET_PLAN_TEMPLATE(state, payload) {
      state.planWithTemplateTrue = payload;
    },
    SET_DISCOUNT_TEMPLATE(state, payload) {
      state.discountTemplate = payload;
    },
    SET_PRODUCT_DISCOUNT_TEMPLATE(state, payload) {
      state.productDiscounts = payload;
    },
    SET_DISCOUNT_CODE(state, payload) {
      state.discountCodeData = payload;
    },
    SET_DOCUMENT(state, payload) {
      state.document = payload;
    },
    SET_EXTERNAL_PLANS(state, payload) {
      state.externalPlans = payload;
    },
    GET_LOCALE_LANGUAGE(state, payload) {
      state.localeLanguage = payload;
    },
    GET_CONTENT_TAG(state, payload) {
      state.contentTagData = payload;
    },
    GET_CONTENT_TAG_VALUE(state, payload) {
      state.contentTagValueData = payload;
    },
    GET_CONTENT_TYPE(state, payload) {
      state.contentType = payload;
    },
    GET_DISCOUNT_CONTENT_TYPE(state, payload) {
      state.discountContentType = payload;
    },
    GET_PROMO_CONTENT_TYPE(state, payload) {
      state.promoContentType = payload;
    },
    SET_PLAN_DISCOUNT_DATA(state, payload) {
      state.planDiscountData = payload;
    },
    SET_PLAN_PROMO_DATA(state, payload) {
      state.planPromoData = payload;
    },
    SET_MAKER_CHECK_ACTION_DATA(state, payload) {
      state.makerChecker = payload;
    },
  },
};
